// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rQEyw","left":"styles_left__3195z"};